import React from 'react';
import { useLineBreakStyles } from './styles';
const NavigationLineBreak = () => {
    const ownClasses = useLineBreakStyles();
    return React.createElement("div", { className: ownClasses.root });
};
export default NavigationLineBreak;
